import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PropertyFundamentals } from '../components/PropertyFundamentals';
import { KeyHighlights } from '../components/KeyHighlights';
import { ContactCTA } from '../components/ContactCTA';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-[#F5F0E8]" data-id="element-80">
      <HeroSection data-id="element-81" />
      <PropertyFundamentals data-id="element-82" />
      <KeyHighlights data-id="element-83" />
      <ContactCTA data-id="element-84" />

      {/* Footer */}
      <footer className="bg-[#152b21] text-white/60 py-8 px-6 text-center text-xs border-t border-white/10" data-id="element-85">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center" data-id="element-86">
          <p data-id="element-87">&copy; 2026 Luxury Real Estate. All rights reserved.</p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-88">
            <a href="#" className="hover:text-white transition-colors" data-id="element-89">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-90">
              Terms of Sale
            </a>
          </div>
        </div>
      </footer>
    </main>;
}